
import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-unresolved
import { ThemeProvider as themePrimary } from 'exo_theme_primary';
import { useTheme } from 'styled-components';
import { providers } from './themeList';

const DefaultThemeProvider = ({ children }) => {
  const currentTheme = useTheme();
  if (currentTheme && Object.entries(currentTheme).length > 0) {
    return children;
  }

  let EffectiveProvider = themePrimary;
  
  if (typeof window !== 'undefined' && window.exo_theme !== undefined) {
    EffectiveProvider = providers[window.exo_theme];
  }

  return (
    <EffectiveProvider>
      {children}
    </EffectiveProvider>
  )
};

DefaultThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default DefaultThemeProvider;
